﻿import $ from "jquery";
import Service from "./Service";

export default function (entryPointId, settings) {
	const $ep = $(`#${entryPointId}`);

	if ($ep.length === 0) {
		return;
	}

	if (ccs_util.isMobile()) {
		settings.openHoverOnClick = true;
		settings.closeOnMouseLeave = false;
	}

	const instance = new Service(settings, $ep);

	$ep.data("logoService", instance);
}
